import createLinkifyPlugin from '@draft-js-plugins/linkify';
import Link from './components/Link';

const linkifyPlugin = createLinkifyPlugin({
    component: Link,
});

export default linkifyPlugin.decorators[0];
